import { Box, Button, Flex, Image, Text } from '@chakra-ui/react';
import { tavoittajaLogoGreen } from '@shared';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export function NotFound({ isOnlyNotFoundText = false }: { isOnlyNotFoundText?: boolean }) {
	const { t } = useTranslation();
	const navigate = useNavigate();

	return (
		<>
			<Helmet>
				<meta name="robots" content="noindex, nofollow" />
			</Helmet>
			<Flex flexDirection="column" alignItems="center" justifyContent="center" height={'100%'} textAlign="center" p={4}>
				<Image src={tavoittajaLogoGreen} alt="404 Not Found" boxSize="200px" objectFit="contain" />

				<Text fontSize="2xl" fontWeight="bold" mt={6}>
					{t('general.oops_not_found')}
				</Text>

				{!isOnlyNotFoundText ? (
					<>
						<Text fontSize="lg" color="gray.500" mt={4}>
							{t('general.this_page_does_not_exist')}
						</Text>

						<Box mt={8}>
							<Button size="lg" mr={4} onClick={() => navigate('/')}>
								{t('general.go_to_homepage')}
							</Button>
						</Box>
					</>
				) : null}
			</Flex>
		</>
	);
}
